import React from "react";
import PublicHeader from "../Public/PublicHeader";
import PublicFooter from "../Public/PublicFooter";

/**
 * AuthPageLayout - Wrapper component for authentication pages
 * Provides consistent header, main content area, and footer
 * Used for login, register, forgot password, reset password pages
 */
const AuthPageLayout = ({ children }) => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <header>
                <div className="container-fluid p-0">
                    <PublicHeader />
                </div>
            </header>
            <main className="flex-grow-1 d-flex align-items-center justify-content-center"
                  style={{ background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)' }}>
                {children}
            </main>
            <footer className="mt-auto">
                <div className="container-fluid p-0">
                    <PublicFooter />
                </div>
            </footer>
        </div>
    );
};

export default AuthPageLayout;
